module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-318.345228f1.jpg";